import React, { useEffect, useRef, useState } from "react";
import Step from "components/MainApp/atoms/Wizard/Step";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";
import useWindowSize from "hooks/useWindowSize";
import TwoOptionModal from "components/MainApp/atoms/Modals/TwoOptionModal";
import backIcon from "assets/images/back-icon.svg";
import infoIcon from "assets/images/info-icon.svg";

import styles from "./Step3.module.scss";
import i18n from 'i18n'
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import { DynamicTooltip } from "components/MainApp/atoms/DynamicTooltip/DynamicTooltip";

const INFO_TOOLTIP_STYLES = {
  backgroundColor: "#494F66",
  padding: "16px",
  maxWidth: "216px",
  textAlign: "start",
  color: "#fff",
  fontFamily: "Ubuntu",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px"
};

export const AddConfigTagStepThree = ({
  printer,
  template,
  setTemplate,
  handleSelectPrinter,
  handleSelectTemplate,
  goBack,
  handleFinish,
  error,
  printers,
  templates,
  enableContinue,
  goBackFunc,
  handleClose,
  handlePersist,
  modalPersistOpen,
  onlyCloseModal,
  handleFinishAndReceptionOrder,
  configTagId
}) => {
  const { isMobile } = useWindowSize();
  const [generateOrder, setGenerateOrder] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const infoIconRef = useRef(null);

  const showTooltip = () => setIsTooltipVisible(true);
  const hideTooltip = () => setIsTooltipVisible(false);

  const handleConfirm = () => {
    handlePersist();
  };

  const handleCloseIntern = () => {
    handleClose();
  };

  const handleCloseIcon = () => {
    onlyCloseModal();
  };

  const handleSubmit = e => {
    if (generateOrder) {
      handleFinishAndReceptionOrder(e);
    } else {
      handleFinish(e);
    }
  };

  const templateOptions = templates.filter(template =>
    template.devices.find(device => device.device === printer?.option)
  )

  const mwidth = isMobile ? "100% " : "322px";
  const modalContent = "";

  useEffect(() => {
    setTemplate(null);
  }, [printer]);

  const stepContent = (
    <form>
      <header>
        <img src={backIcon} draggable={false} onClick={goBackFunc} />
        <h4>{i18n.t("select.printer")}</h4>
      </header>
      <div className={styles["add-tag-wizard-step-three-content"]}>
        <div
          className={styles["add-tag-wizard-step-three-field"]}
          data-automation-id="input-printer"
        >
          <MainDropdownInput
            required={true}
            id={"printer"}
            name="printer"
            selectedOption={printer ? printer : ""}
            handleSelection={selectedOption =>
              handleSelectPrinter(selectedOption, "printer")
            }
            maxLength={50}
            options={printers}
            placeholder={i18n.t("select.printer")}
            label={i18n.t("select.printer")}
            error={error.printer && error.printer}
          />
          <MainDropdownInput
            required={true}
            id={"template"}
            name="template"
            selectedOption={template ? template : ""}
            handleSelection={selectedOption =>
              handleSelectTemplate(selectedOption, "template")
            }
            options={templateOptions}
            placeholder={i18n.t("select")}
            label={i18n.t("template")}
            disabled={!templateOptions.length}
          />
          {isMobile && <Checkbox
            label={i18n.t("generate.entry.order")}
            handleChange={() => setGenerateOrder(!generateOrder)}
            checked={generateOrder}
          />}
        </div>
        <div className={styles["add-tag-wizard-step-three-action-wrapper"]}>
          {!isMobile && <div>
            <Checkbox
              label={i18n.t("generate.entry.order")}
              handleChange={() => setGenerateOrder(!generateOrder)}
              checked={generateOrder}
            />
            <img
              src={infoIcon}
              draggable={false}
              ref={infoIconRef}
              onMouseEnter={showTooltip}
              onMouseLeave={hideTooltip}
            />
            <DynamicTooltip
              targetRef={infoIconRef}
              isTooltipVisible={isTooltipVisible}
              styles={INFO_TOOLTIP_STYLES}
            >
              {i18n.t("finish.printing.redirect.to.order")}
            </DynamicTooltip>
          </div>}
          <button
            type="submit"
            className={`${styles["add-tag-wizard-step-three-action-button"]} ${!enableContinue || !configTagId &&
              styles["disabled"]}`}
            onClick={handleSubmit}
            disabled={!configTagId}
          >
            {i18n.t("print").toUpperCase()}
          </button>
        </div>
      </div>
    </form>
  );

  return (
    <div className={styles["add-tag-wizard-step-three-container"]}>
      <Step content={stepContent} />
      <TwoOptionModal
        open={modalPersistOpen}
        title={i18n.t("pause.printing.tags")}
        subtitle={
          <span style={{ fontFamily: 'Ubuntu-Medium', color: '#676F8F' }}>
            {i18n.t("exit.and.save.question")}
          </span>
        }
        closeLabel={i18n.t("exit.without.saving")}
        confirmLabel={i18n.t("save").toUpperCase()}
        handleClose={handleCloseIntern}
        handleConfirm={handleConfirm}
        modalContent={modalContent}
        confirmDisabled={false}
        closeable={true}
        handleCloseIcon={handleCloseIcon}
      />
    </div>
  );
};

export default AddConfigTagStepThree;
